<template>
  <base-modal :height="height" :name="name" :width="width" @closed="$emit('cancel')">
    <div class="ml-modal__container">
      <!-- Title -->
      <div class="ml-modal__title text-center" v-html="title"></div>
      <!-- End of the title -->

      <!-- Body -->
      <slot></slot>
      <!-- End of body -->

      <!-- Footer -->
      <div class="ml-modal__footer">
        <button @click="$emit('cancel')" class="ml-btn ml-btn--white">{{ cancelText }}</button>
        <button @click="$emit('save')" class="ml-btn tingg-primary-button">
          <i :class="`fas fa-chevron-${actionIcon}`" v-show="noIcon"></i>
          <span>{{ action }}</span>
        </button>
      </div>
      <!-- End of footer -->
    </div>
  </base-modal>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    actionIcon: {
      type: String,
      default: 'save'
    },
    action: {
      type: String
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    height: {
      type: String,
      default: 'auto'
    },
    name: {
      type: String,
      required: true
    },
    noIcon: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    width: {
      type: String,
      default: '350px'
    }
  }
}
</script>

<style lang="scss">
@import "../styles/theme";

.ml-modal__container {
  border-top: 3px solid $tingg-purple;
  padding: 10px 15px;
  width: 100%;
}

.ml-modal__title {
  font-size: 18px;
  margin: 5px 0 15px;
}

.ml-modal__footer {
  align-items: center;
  display: flex;
  justify-content: flex-end;


  margin-top: 30px;

  .ml-btn:last-child {
    margin-right: 0;
  }
}

// Override the modal overlay
.v--modal-overlay {
  background-color: rgba(255, 255, 255, 0.75) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue